import Shell from "@/pages/Shell";
import { Seo } from "@/components/Seo";
import { Books } from "@/components/Books";

export default function BooksPage() {
  return (
    <Shell>
      {(scrollToId) => (
        <>
          <Seo
            title="Books by Charles McKuhn — Faith, Revival & Leadership"
            description="Explore the published books and writings of Charles A. McKuhn Jr. on spiritual renewal, servant leadership, and building communities grounded in hope and service."
            path="/books"
          />
          <h1 className="sr-only">Books by Charles McKuhn</h1>
          <Books scrollToId={scrollToId} />
        </>
      )}
    </Shell>
  );
}
